// HeroAvatar.js — Avatar « héros Worms » personnalisable pour le profil.
// Stocké dans le champ avatar_url du compte sous la forme  vgworm:<variant>:<couleurBg>
// (ex: vgworm:superSaiyan:#7c3aed). Rendu comme un ver héros sur un fond coloré, sinon on
// retombe sur l'image classique ou les initiales.
import React from 'react';
import WormHero from './WormHero';

export const HERO_BGS = ['#7c3aed', '#06b6d4', '#ef4444', '#22c55e', '#f59e0b', '#1a1a35'];
// Personnages « autres univers » (emoji) — variés, pas que des vers.
export const CHAR_EMOJIS = ['🦸', '🦹', '🥷', '🧙', '🧛', '🧟', '🧝', '🧚', '🤖', '👽', '👾', '🐉', '🦖', '🐺', '🦊', '🐯', '🦁', '🐲', '👑', '💀', '🎃', '🤡', '👻', '🦉'];

export function parseHeroAvatar(url) {
  const s = String(url || '');
  const m = /^vgworm:([a-zA-Z]+)(?::(#[0-9a-fA-F]{3,6}))?$/.exec(s);
  if (m) return { type: 'worm', variant: m[1], bg: m[2] || '#7c3aed' };
  const e = /^vgemoji:([^:]+)(?::(#[0-9a-fA-F]{3,6}))?$/.exec(s);
  if (e) return { type: 'emoji', emoji: e[1], bg: e[2] || '#7c3aed' };
  return null;
}
export function heroAvatarUrl(variant, bg) { return `vgworm:${variant}:${bg || '#7c3aed'}`; }
export function emojiAvatarUrl(emoji, bg) { return `vgemoji:${emoji}:${bg || '#7c3aed'}`; }

// Un avatar « perso » (ver héros OU emoji) sur son fond coloré (rond).
export default function HeroAvatar({ url, size = 84 }) {
  const h = parseHeroAvatar(url);
  if (!h) return null;
  return (
    <span style={{ width: size, height: size, borderRadius: '50%', background: h.bg, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
      {h.type === 'emoji'
        ? <span style={{ fontSize: Math.round(size * 0.56), lineHeight: 1 }}>{h.emoji}</span>
        : <WormHero variant={h.variant} size={Math.round(size * 0.92)} />}
    </span>
  );
}

// Contenu générique d'un avatar : perso (ver/emoji), image (http/data), sinon initiales.
export function AvatarInner({ url, name, size = 84 }) {
  const h = parseHeroAvatar(url);
  if (h) return <HeroAvatar url={url} size={size} />;
  if (url) return <img src={url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />;
  return <>{String(name || '?').slice(0, 2).toUpperCase()}</>;
}
